import serviceClient from "./serviceClient";

const apiRequest = async (url, data = {}, method = "POST") => {
  try {
    const upperMethod = method.toUpperCase();

    const methodsMap = {
      GET: () => serviceClient.get(url, { params: data }),
      POST: () => serviceClient.post(url, data),
      PUT: () => serviceClient.put(url, data),
      DELETE: () => serviceClient.delete(url, { data }),
    };

    if (!methodsMap[upperMethod]) {
      throw new Error(`Unsupported method: ${method}`);
    }

    const response = await methodsMap[upperMethod]();
    return response.data;
  } catch (error) {
    console.error(`API Error(${method} ${url}):`, error);
    throw error.response?.data || { message: "An unexpected error occurred." };
  }
};

// AUTH
export const changePassword = (data, id) =>
  apiRequest(`/auth/changePassword`, data, "put");
// AUTH

// OB TRANSACTION
export const getOBTransactionList = (data) =>
  apiRequest("/obTransaction/getOBTransactionList", data, "get");

export const createOBTransaction = (data) =>
  apiRequest("/obTransaction/createOBTransaction", data, "post");

export const updateOBTransaction = (data, id) =>
  apiRequest(`/obTransaction/updateOBTransaction/${id}`, data, "put");

export const deleteOBTransaction = (id) =>
  apiRequest(`/obTransaction/deleteOBTransaction/${id}`, {}, "delete");
// OB TRANSACTION

// PAMP TRANSACTION
export const getGoldBarTransactionList = (data) =>
  apiRequest("/pampTransaction/getPampTransactionList", data, "get");

export const createGoldBarTransaction = (data) =>
  apiRequest("/pampTransaction/createPampTransaction", data);

export const updateGoldBarTransaction = (data) =>
  apiRequest("/pampTransaction/updatePampTransaction", data);

export const deleteGoldBarTransaction = (data) =>
  apiRequest("/pampTransaction/deletePampTransaction", data);
// PAMP TRANSACTION

// TRANSACTION
export const getTransactionList = async (data) =>
  apiRequest("/transaction/getTransactionList", data, "get");

export const getTransaction = async (transactionData) =>
  apiRequest("/transaction/getTransaction", transactionData);

export const createTransaction = async (transactionData) =>
  apiRequest("/transaction/createTransaction", transactionData);

export const updateTransaction = async (transactionData) =>
  apiRequest("/transaction/updateTransaction", transactionData);

export const deleteTransaction = async (transactionData) =>
  apiRequest("/transaction/deleteTransaction", transactionData);

/* Services that is used by order clearance module */
export const updateOrderClearanceTransactionList = async (transactionData) =>
  apiRequest(
    "/transaction/updateOrderClearanceTransactionList",
    transactionData
  );
// TRANSACTION

// PROMOTION
export const getPromotionList = (data) =>
  apiRequest("/promotion/getPromotionList", data, "get");

export const getValidPromotionList = async (promotionData) =>
  apiRequest("/promotion/getValidPromotionList", promotionData);

export const getTopActivePromotionList = async (promotionData) =>
  apiRequest("/promotion/getTopActivePromotionList", promotionData);

export const getPromotion = async (promotionData) =>
  apiRequest("/promotion/getPromotion", promotionData);

export const createPromotion = async (promotionData) =>
  apiRequest("/promotion/createPromotion", promotionData);

export const updatePromotion = async (promotionData) =>
  apiRequest("/promotion/updatePromotion", promotionData);

export const expirePromotion = async (promotionData) =>
  apiRequest("/promotion/expirePromotion", promotionData);

export const deletePromotion = async (promotionData) =>
  apiRequest("/promotion/deletePromotion", promotionData);

// Services that is used by order clearance module *
export const getOrderClearancePromotionList = async () =>
  apiRequest("/promotion/getOrderClearancePromotionList");
// PROMOTION

// USER
export const getUserList = (userData) =>
  apiRequest("/users/getUserList", userData, "get");

export const getUser = (userData) => apiRequest("/users/getUser", userData);

export const createUser = (userData) =>
  apiRequest("/users/createUser", userData);

export const updateUser = (userData) =>
  apiRequest("/users/updateUser", userData);

export const deleteUser = (userData) =>
  apiRequest("/users/deleteUser", userData);

export const resetUserAccountPassword = (userData) =>
  apiRequest("/users/resetUserAccountPassword", userData);
// USER

// BRANCH
export const getBranchList = async (branchData) =>
  apiRequest("/branch/getBranchList", branchData, "get");

export const getBranch = async (branchData) =>
  apiRequest("/branch/getBranch", branchData);

export const createBranch = async (branchData) =>
  apiRequest("/branch/createBranch", branchData);

export const updateBranch = async (branchData) =>
  apiRequest("/branch/updateBranch", branchData);

export const deleteBranch = async (branchData) =>
  apiRequest("/branch/deleteBranch", branchData);
// BRANCH

// ORDER CLEARANCE
export const getOrderClearanceList = async (orderClearanceData) =>
  apiRequest(
    "/orderClearance/getOrderClearanceList",
    orderClearanceData,
    "get"
  );
// ORDER CLEARANCE

// MARKETING CAMPAIGN
export const getMarketingCampaignList = (data) =>
  apiRequest("/marketingCampaign/getMarketingCampaignList", data, "get");

export const getMarketingCampaign = (id, data) =>
  apiRequest(`/marketingCampaign/getMarketingCampaign/${id}`, data, "get");

export const createMarketingCampaign = (data) =>
  apiRequest("/marketingCampaign/createMarketingCampaign", data, "post");

export const updateMarketingCampaign = (data, id) =>
  apiRequest(`/marketingCampaign/updateMarketingCampaign/${id}`, data, "put");

export const createMarketingCampaignItem = (data, id) =>
  apiRequest(
    `/marketingCampaign/createMarketingCampaignItem/${id}`,
    data,
    "post"
  );

export const updateMarketingCampaignItem = (data, id) =>
  apiRequest(
    `/marketingCampaign/updateMarketingCampaignItem/${id}`,
    data,
    "put"
  );

export const updateMarketingCampaignItemStatus = (data, id) =>
  apiRequest(
    `/marketingCampaign/updateMarketingCampaignItemStatus/${id}`,
    data,
    "put"
  );

export const deleteMarketingCampaign = (id) =>
  apiRequest(`/marketingCampaign/deleteMarketingCampaign/${id}`, {}, "delete");

export const deleteMarketingCampaignItem = (id) =>
  apiRequest(
    `/marketingCampaign/deleteMarketingCampaignItem/${id}`,
    {},
    "delete"
  );

export const getBloggers = (data) =>
  apiRequest("/marketingCampaign/getBloggers", data, "get");

export const searchBloggers = (data) =>
  apiRequest("/marketingCampaign/searchBloggers", data, "get");
// MARKETING CAMPAIGN

// GOLD TRADE IN
export const getGoldTradeInList = (data) =>
  apiRequest("/goldTradeIn/getGoldTradeInList", data, "get");

export const createGoldTradeIn = (data) =>
  apiRequest("/goldTradeIn/createGoldTradeIn", data, "post");

export const updateGoldTradeIn = (data, id) =>
  apiRequest(`/goldTradeIn/updateGoldTradeIn/${id}`, data, "put");

export const getGoldTradeIn = (id) =>
  apiRequest(`/goldTradeIn/getGoldTradeIn/${id}`, {}, "get");

export const createGoldTradeInItem = (data, id) =>
  apiRequest(`/goldTradeIn/createGoldTradeInItem/${id}`, data, "post");

export const updateGoldTradeInItem = (data, id) =>
  apiRequest(`/goldTradeIn/updateGoldTradeInItem/${id}`, data, "put");

export const deleteGoldTradeIn = (id) =>
  apiRequest(`/goldTradeIn/deleteGoldTradeIn/${id}`, {}, "delete");

export const deleteGoldTradeInItem = (id) =>
  apiRequest(`/goldTradeIn/deleteGoldTradeInItem/${id}`, {}, "delete");

export const updateGoldTradeInStatus = (data, id) =>
  apiRequest(`/goldTradeIn/updateGoldTradeInStatus/${id}`, data, "put");

export const updateBatchGoldTradeInStatus = (data) =>
  apiRequest(`/goldTradeIn/updateBatchGoldTradeInStatus`, data, "put");

export const updateGoldTradeInDuplicate = (id) =>
  apiRequest(`/goldTradeIn/markAsNonDuplicate/${id}`, {}, "put");

export const getGoldTradeInSettings = () =>
  apiRequest("/goldTradeIn/getGoldTradeInSettings", {}, "get");

export const updateGoldTradeInSettings = (data) =>
  apiRequest("/goldTradeIn/updateGoldTradeInSettings", data, "post");

export const getGoldTradeInHistories = (id) =>
  apiRequest(`/goldTradeIn/getGoldTradeInHistories/${id}`, {}, "get");

// GOLD TRADE IN

// CUSTOMER LIST
export const getCustomerLists = (data) =>
  apiRequest("/customerList/getCustomerLists", data, "get");

export const getCustomerListByReferenceNo = (id) =>
  apiRequest(`/customerList/getCustomerListByReferenceNo/${id}`, {}, "get");

export const createCustomerList = (data) =>
  apiRequest("/customerList/createCustomerList", data, "post");

export const updateCustomerList = (data, id) =>
  apiRequest(`/customerList/updateCustomerList/${id}`, data, "put");

export const deleteCustomerList = (id) =>
  apiRequest(`/customerList/deleteCustomerList/${id}`, {}, "delete");

export const updateCustomerListStatus = (data, id) =>
  apiRequest(`/customerList/updateCustomerListStatus/${id}`, data, "put");

export const getDeliveredCustomerLists = (data) =>
  apiRequest("/customerList/getDeliveredCustomerLists", data, "get");

export const bulkUpdateCompletedCCItems = (data) =>
  apiRequest(`/customerList/bulkUpdateCompletedCCItems`, data, "put");

export const createCustomerListByLiveOrder = (data) =>
  apiRequest("/customerList/createCustomerListByLiveOrder", data, "post");
// CUSTOMER LIST

// PLATFORM PRODUCT
export const getPlatformProductList = (data) =>
  apiRequest("/platformProduct/getPlatformProductList", data, "get");

export const createPlatformProduct = (data) =>
  apiRequest("/platformProduct/createPlatformProduct", data, "post");

export const updatePlatformProduct = (data, id) =>
  apiRequest(`/platformProduct/updatePlatformProduct/${id}`, data, "put");

export const deletePlatformProduct = (id) =>
  apiRequest(`/platformProduct/deletePlatformProduct/${id}`, {}, "delete");

export const getPlatformProductSettings = () =>
  apiRequest("/platformProduct/getPlatformProductSettings", {}, "get");

export const updatePlatformProductSettings = (data) =>
  apiRequest("/platformProduct/updatePlatformProductSettings", data, "post");

// PLATFORM PRODUCT

// GOLD PRICE SETTING
export const getGoldPriceSettings = () =>
  apiRequest("/goldPrice/getGoldPriceSettings", {}, "get");

export const getGoldPrices = () =>
  apiRequest("/goldPrice/getGoldPrices", {}, "get");

export const updateGoldPriceSettings = (data) =>
  apiRequest("/goldPrice/updateGoldPriceSettings", data, "post");

export const getLatestGoldPrice = () =>
  apiRequest("/goldPrice/getLatestGoldPrice", {}, "get");

export const manualUpdateGoldPrice = () =>
  apiRequest("/goldPrice/manualUpdateGoldPrice", {}, "get");

// GOLD PRICE SETTING

// FB LIVE SETTING
export const getFBLiveLists = (data) =>
  apiRequest("/fbLive/getFBLiveLists", data, "get");

export const createFBLive = (data) =>
  apiRequest("/fbLive/createFBLive", data, "post");

export const updateFBLive = (data) =>
  apiRequest("/fbLive/updateFBLive", data, "post");

export const deleteFBLive = (id) =>
  apiRequest(`/fbLive/deleteFBLive/${id}`, {}, "delete");

export const getFBLive = (id, data) =>
  apiRequest(`/fbLive/getFBLive/${id}`, data, "get");

export const getFBLiveProducts = (id) =>
  apiRequest(`/fbLive/getFBLiveProducts/${id}`, {}, "get");

export const createFBLiveProduct = (data) =>
  apiRequest("/fbLive/createProduct", data, "post");

export const updateFBLiveProduct = (data) =>
  apiRequest("/fbLive/updateProduct", data, "post");

export const deleteFBLiveProduct = (id) =>
  apiRequest(`/fbLive/deleteProduct/${id}`, {}, "delete");

export const getProductListing = (id) =>
  apiRequest(`/fbLive/getLiveProductListingByLiveId/${id}`, {}, "get");

export const updateFBLiveProductSortOrder = (data) =>
  apiRequest("/fbLive/updateFBLiveProductSortOrder", data, "put");

export const updateProductStockQty = (data) =>
  apiRequest("/fbLive/updateProductStockQty", data, "put");
// FB LIVE SETTING

// FB LIVE
export const getFbLiveOrderList = (data) =>
  apiRequest("/fbLive/getOrderList", data, "get");

export const getFbLiveOrder = (id) =>
  apiRequest(`/fbLive/getOrder/${id}`, {}, "get");

export const getFbLiveOrderHistories = (id, data) =>
  apiRequest(`/fbLive/getOrderHistories/${id}`, data, "get");

export const createFbLiveOrder = (data) =>
  apiRequest("/fbLive/createOrder", data, "post");

export const updateFbLiveOrder = (data, id) =>
  apiRequest(`/fbLive/updateOrder/${id}`, data, "put");

export const deleteFbLiveOrder = (id) =>
  apiRequest(`/fbLive/deleteOrder/${id}`, {}, "delete");

export const updateFbLiveOrderStatus = (data, id) =>
  apiRequest(`/fbLive/updateOrderStatus/${id}`, data, "put");

export const updateOrderBankInfoFlag = (data, id) =>
  apiRequest(`/fbLive/updateOrderBankInfoFlag/${id}`, data, "put");

export const updateOrderBankAmountFlag = (data, id) =>
  apiRequest(`/fbLive/updateOrderBankAmountFlag/${id}`, data, "put");

export const updateOrderBank = (data, id) =>
  apiRequest(`/fbLive/updateOrderBank/${id}`, data, "put");

export const updateOrderCSNo = (data, id) =>
  apiRequest(`/fbLive/updateOrderCSNo/${id}`, data, "put");

export const updateOrderProductItemCode = (data, id) =>
  apiRequest(`/fbLive/updateOrderProductItemCode/${id}`, data, "put");

export const submitRejectOrder = (data, id) =>
  apiRequest(`/fbLive/submitRejectOrder/${id}`, data, "put");

export const saveDraft = (data) =>
  apiRequest(`/fbLive/saveDraft`, data, "post");

export const getFbLiveComment = (data) =>
  apiRequest(`/fbLive/getFbLiveComment`, data, "get");
// FB LIVE

// COUNTRY
export const getCountryList = (data) =>
  apiRequest("/country/getCountryList", data, "get");

export const getZoneList = (data) =>
  apiRequest("/country/getZoneList", data, "get");
// COUNTRY
